import React from "react";
import type { ReactNode } from "react";
import { Grid, Typography } from "@mui/material";
import { PageHeaderBar } from "components/PageHeaderBar/PageHeaderBar";
import { PolicyAuthorized } from "components/authorization/PolicyAuthorized";
import type { RbacPolicy } from "components/authorization/RbacPolicies";

export interface PageHeadingProps {
  headingText: string;
  actionItems?: {
    policy: RbacPolicy;
    component?: ReactNode;
  }[];
}

export function PageHeading({ headingText, actionItems }: PageHeadingProps) {
  return (
    <PageHeaderBar>
      <Grid container spacing={2}>
        <Grid size={4}>
          <Typography variant="h4" noWrap>
            {headingText}
          </Typography>
        </Grid>
        <Grid container size={8} sx={{ justifyContent: "flex-end" }}>
          {actionItems
            ?.filter((action) => !!action.component)
            .map((action, index) => (
              <Grid key={index}>
                <PolicyAuthorized policies={action.policy}>{action.component}</PolicyAuthorized>
              </Grid>
            ))}
        </Grid>
      </Grid>
    </PageHeaderBar>
  );
}
